import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ComList from '../ComList';

class UpdateLanguage extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const params = {
            ...(record || {}),
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        }, () => {
            this.queryVitaeList('LANGUAGE_TYPE');
            this.queryVitaeList('LANGUAGE_LEVEL');
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            languageOptions: [],
            speakOptions: [],
        });
    }

    queryVitaeList = (typeName) => {
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeList,
            data: {typeName},
            dataType: 'json',
            doneResult: res => {
                const { vitaeList = [] } = res;
                const options = vitaeList.map(item => {
                    const { vitaeDictId, chName, enName, childList } = item;
                    return {
                        zh: chName,
                        en: enName,
                        value: vitaeDictId,
                        child: childList,
                    };
                });
                if (typeName === 'LANGUAGE_TYPE') {
                    this.setState({ languageOptions: options });
                } else if (typeName === 'LANGUAGE_LEVEL') {
                    this.setState({ speakOptions: options });
                }
            }
        };
        $.sendRequest(options);
    }


    getRenderList = () => {
        const { isChinese } = this.props;
        const { languageOptions = [], speakOptions = [] } = this.state;
        languageOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        speakOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        const renderList = [{
            zh: '语种',
            en: 'Language',
            key: 'languageId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                disabled: !isChinese,
                list: languageOptions,
                style: { width: 200 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            }
        }, {
            key: isChinese ? 'languageOtherChinese' : 'languageOtherEnglish',
            require: true,
            colon: false,
            option: {
                type: 'input',
                style: { width: 200 },
                placeholder: isChinese ? '补充其他说明' : 'Please supply other instructions',
            },
            display: {
                symbol: 'eq',
                key: 'languageId',
                toName: true,
                value: isChinese ? '其他' : 'Others',
            }
        }, {
            zh: '说',
            en: 'Speaking',
            key: 'speakingId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                list: speakOptions,
                disabled: !isChinese,
                style: { width: 200 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            }
        }, {
            zh: '读',
            en: 'Reading',
            key: 'readingId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                list: speakOptions,
                disabled: !isChinese,
                style: { width: 200 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            }
        }, {
            zh: '写',
            en: 'Writing',
            key: 'writingId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                list: speakOptions,
                disabled: !isChinese,
                style: { width: 200 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            }
        }];
        const setName = (item) => {
            if (isChinese) {
                item.name = item.zh;
            } else {
                item.name = item.en;
            }
        };
        const loopArr = (arr) => {
            if (Array.isArray(arr)) {
                arr.forEach(item => loopArr(item));
            } else {
                setName(arr);
            }
        };
        loopArr(renderList);
        this.renderList = renderList;
    }

    checkValue = param => {
        const { params } = this.state;
        const { name, key, require, option, warning, display } = param;
        const { placeholder } = option;
        
        let noError = true;
        if (require) {
            if (!params[key] && !display) {
                message.warning(`${placeholder}${warning || name || ''}`);
                noError = false;
            } else {
                if (display) {
                    const { symbol, key, value = null } = display;
                    if (symbol === 'eq') {
                        if (value) {
                            const list = this.renderList || [];
                            const tar = list.find(i => i.key === key);
                            const arr = tar.option.list || [];
                            const o = arr.find(a => a.value == params[key]);
                            if (o && o.name === value && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        } else {
                            if (params[key] && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        }
                    }
                }
            }
        }
        return noError;
    }
    
    submit = () => {
        const {
            isEdit,
            params,
        } = this.state;
        const { userId, isChinese } = this.props;
        this.getRenderList();
        const renderList = this.renderList || [];
        const hasError = renderList.every(item => {
            if (Array.isArray(item)) {
                return item.every(i => this.checkValue(i));
            } else {
               return this.checkValue(item);
            }
        });
        if (!hasError) {
            return;
        }

        params.type = isChinese ? 'CHINESE' : 'ENGLISH';
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.saveVitaeLanguage,
            data: {
                userId,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        const { isChinese } = this.props;
        params[key] = value;
        if (key === 'languageId') {
            const languageOther = isChinese ? 'languageOtherChinese' : 'languageOtherEnglish';
            params[languageOther] = '';
        }
        this.setState({ params });
    }

    render() {
        const { isEdit, visible, loading, params } = this.state;
        this.getRenderList();
        const list = this.renderList || [];
        return (
            <Modal
                title={`${isEdit ? '修改' : '新增'}语言/流利度`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                confirmLoading={loading}
                maskClosable={false}
                width="400px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ComList
                            list={list}
                            params={params}
                            onChange={(value, key) => this.handleChange(value, key)}
                        />
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateLanguage;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/UpdateLanguage.js